var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperplane = function SvgPaperplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.69 6a1.4 1.4 0 0 0-1.57.19l-27.94 24a1.89 1.89 0 0 0 .6 3.22l8 2.9L20.57 43a1.61 1.61 0 0 0 1.2 1.17 2.3 2.3 0 0 0 .37 0 1.58 1.58 0 0 0 1.18-.52l4.1-4.3 8.42 3.12a1.59 1.59 0 0 0 1.42-.17 1.61 1.61 0 0 0 .74-1.23l2.47-33.72A1.4 1.4 0 0 0 39.69 6M24.31 38.19l.78.28L24 39.63zm-1.84-2.08-.63 2.69-.84-3.13 9.52-14.21zm-9-5.72 21.75-19.07-15.9 22.75-5.52-2a1 1 0 0 1-.32-1.68zm21 9.14L25.12 36l12.69-23.84-2 26.51a1 1 0 0 1-1.3.86z"
  })));
};
export default SvgPaperplane;